import classNames from './ToggleSwitch.module.scss';
import classes from 'classnames';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
}

const ToggleSwitch = ({ checked, onChange, disabled, ariaLabel, className }: ToggleSwitchProps) => {
  return (
    <button
      type='button'
      role='switch'
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={classes(classNames.toggle, { [classNames.on]: checked }, className)}
      onClick={() => !disabled && onChange(!checked)}
    >
      <span className={classNames.thumb} />
    </button>
  );
};

export default ToggleSwitch;
